export default __webpack_public_path__ + "c751eaf7c9e2dfed4b26f6ca5d9f80b7.svg";